import { useEffect } from 'react'

import { notification } from 'antd'

import { DesignSystemProvider } from '../../theme/Provider'

import { registerNotificationBridge } from './notificationBridge'
import { useStyles } from './styles'

const NotificationRegistrarInner: React.FC = () => {
  const [api, holder] = notification.useNotification({
    stack: false,
    pauseOnHover: true,
    top: 24
  })
  const { styles } = useStyles()

  useEffect(() => {
    registerNotificationBridge({ notification: api, styles })
  }, [api, styles])

  return holder
}

export const DesignSystemNotificationRegistrar: React.FC = () => (
  <DesignSystemProvider>
    <NotificationRegistrarInner />
  </DesignSystemProvider>
)
